import React from "react";
import { Star, Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  author: "\nB",
  quote: "I had a great experience with Gold Star Executive Cleaning, I wasn’t expecting the great attention to detail when they first cleaned my home. Everything felt so fresh and the whole experience was professional with great communication. I have used this service several times since and highly recommend them.\n\n",
  position: "Facilities Manager"
}, {
  author: "Milly Connors",
  quote: "I was very impressed with the high standard of cleaning services provided by Goldstar when cleaning my home . Staff were very friendly and professional as they thoroughly cleaned every room, including bathrooms and hard to reach areas. Would highly recommend them to anyone looking for a good value for money cleaning service",
  position: "Building Supervisor"
}, {
  author: "Jay Shah",
  quote: "Good cleaning company\n\n",
  position: "Operations Director"
}];
export default function ExecutiveClientPraise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="executive-client-praise" className="dark bg-background text-foreground py-24 relative overflow-hidden">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none select-none opacity-10">
        <Quote className="size-[400px] text-primary rotate-12" strokeWidth={1} />
      </div>

      <div ref={ref} className={`container mx-auto px-4 relative z-10 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <div className="max-w-4xl mx-auto">
          <Carousel opts={{
          align: "center",
          loop: true
        }} className="w-full">
            <CarouselContent>
              {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i}>
                  <div className="flex flex-col items-center text-center px-4 md:px-12 py-8">
                    {}
                    <div className="flex gap-1.5 mb-8">
                      {[...Array(5)].map((_, starIndex) => <Star key={starIndex} className="size-6 fill-primary text-primary" strokeWidth={0} />)}
                    </div>

                    {}
                    <blockquote className="mb-10">
                      <p className="text-2xl md:text-4xl font-serif italic leading-relaxed text-white">
                        &ldquo;{testimonial.quote}&rdquo;
                      </p>
                    </blockquote>

                    {}
                    <div className="flex flex-col items-center gap-1">
                      <cite className="not-italic text-xl font-semibold text-primary tracking-wide">
                        {testimonial.author}
                      </cite>
                      
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>

            {}
            <div className="hidden md:block">
              <CarouselPrevious className="border-primary/20 text-primary hover:bg-primary/10 hover:text-primary -left-12 h-12 w-12" />
              <CarouselNext className="border-primary/20 text-primary hover:bg-primary/10 hover:text-primary -right-12 h-12 w-12" />
            </div>
            
            {}
            <div className="flex justify-center gap-4 mt-8 md:hidden">
               <CarouselPrevious className="static translate-y-0 border-primary/20 text-primary hover:bg-primary/10 hover:text-primary h-10 w-10" />
               <CarouselNext className="static translate-y-0 border-primary/20 text-primary hover:bg-primary/10 hover:text-primary h-10 w-10" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}